import { Flex, Th, Tr } from '@chakra-ui/react';
import { CheckItem } from './CheckItem';

export function Item({ item, refresh }) {
  return (
    <Tr>
      <Th>{item.nunota}</Th>
      <Th>{item.numinno}</Th>
      <Th>{item.nfe}</Th>
      <Th>
        <Flex flexDir="column" gap={2}>
          <span>{item.dia_mes_dt_frete}</span>
          <span>{item.hora_dt_frete}</span>
        </Flex>
      </Th>
      <Th>{item.nome_empresa}</Th>
      <Th>{item.nome_vendedor}</Th>
      <Th>{item.vlr_frete}</Th>
      <Th>{item.valor_real_frete}</Th>
      <Th>{item.frete30}</Th>
      <Th>{item.frete_over}</Th>
      <Th>{item.transportadora}</Th>
      <Th textAlign="center">
        <CheckItem
          item={item}
          validacao_frete="F"
          refresh={refresh}
          isChecked={item.valida_financeiro === 'S'}
        />
      </Th>
      <Th textAlign="center">
        <CheckItem
          item={item}
          validacao_frete="R"
          refresh={refresh}
          isChecked={item.valida_rodrigo === 'S'}
        />
      </Th>
    </Tr>
  );
}
